/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Cta_PaidInputs */

const en_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascend Now`)
};

const es_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascender ahora`)
};

const fr_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascension Maintenant`)
};

const de_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt aufsteigen`)
};

const ja_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ上昇する`)
};

const zh_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即跃升`)
};

const ar_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ارتقِ الآن`)
};

const id_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naik Kelas Sekarang`)
};

const it_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascendi Ora`)
};

const ru_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повысить уровень сейчас`)
};

const pt_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevar Nível Agora`)
};

const ko_tier_cta_paid = /** @type {(inputs: Tier_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 업그레이드`)
};

/**
* | output |
* | --- |
* | "Ascend Now" |
*
* @param {Tier_Cta_PaidInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_cta_paid = /** @type {((inputs?: Tier_Cta_PaidInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Cta_PaidInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_cta_paid(inputs)
	if (locale === "es") return es_tier_cta_paid(inputs)
	if (locale === "fr") return fr_tier_cta_paid(inputs)
	if (locale === "de") return de_tier_cta_paid(inputs)
	if (locale === "ja") return ja_tier_cta_paid(inputs)
	if (locale === "zh") return zh_tier_cta_paid(inputs)
	if (locale === "ar") return ar_tier_cta_paid(inputs)
	if (locale === "id") return id_tier_cta_paid(inputs)
	if (locale === "it") return it_tier_cta_paid(inputs)
	if (locale === "ru") return ru_tier_cta_paid(inputs)
	if (locale === "pt") return pt_tier_cta_paid(inputs)
	return ko_tier_cta_paid(inputs)
});